<template>
  <div>
    <div class="home">
      <p class="p1">
        {{ $t('common.p106') }}
      </p>
      <p class="p2">
        {{ $t('common.p107') }}
      </p>
      <div class="content">
        <div
          class="button1"
          @click="toHome()"
        >
          <p>{{ $t('common.p108') }}</p>
        </div>
      </div>
    </div>
    <div class="divider_color" />
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data() {
    return {};
  },
  methods: {
    toHome() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  .p1 {
    font-size: 50px;
    line-height: 70px;
    margin-top: 40px;
    font-weight: bold;
    color: #242424;
    padding: 0px 24px;
  }
  .p2 {
    font-size: 24px;
    margin-bottom: 30px;
    color: #242424;
    padding: 0px 24px;
  }
  .content {
    position: relative;
    height: 1099px;
    background-image: url(/official_mobile/static/img/404/01.jpg);
    background-repeat: no-repeat;
    background-position: center center;
    background-size: 100% auto;
    .button1 {
      position: absolute;
      width: 420px;
      height: 60px;
      background-color: #ffffff;
      text-align: center;
      cursor: pointer;
      top: 100px;
      left: 24px;
      p {
        line-height: 60px;
        font-size: 22px;
        color: #4a965b;
      }
    }
  }
}
</style>
